"use client";

import * as React from "react";
import {
  Text,
  SectionCard,
  CardTitle,
  CardDescription,
  Section,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Button,
} from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsDialog() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Dialog
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A modal dialog that interrupts the user with important content.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/dialog" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A basic dialog with trigger</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Dialog>
            <DialogTrigger asChild>
              <Button variant="outline">Open Dialog</Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
              <DialogHeader>
                <DialogTitle>Edit Profile</DialogTitle>
                <DialogDescription>
                  Make changes to your profile here. Click save when you're done.
                </DialogDescription>
              </DialogHeader>
              <div className="py-4">
                <p className="text-sm text-muted-foreground">
                  Dialog content goes here.
                </p>
              </div>
              <DialogFooter>
                <Button type="submit">Save changes</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Components</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Component</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">Dialog</td>
                <td className="py-2 text-muted-foreground">Root component managing state</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">DialogTrigger</td>
                <td className="py-2 text-muted-foreground">Element that opens the dialog</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">DialogContent</td>
                <td className="py-2 text-muted-foreground">The modal content container</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">DialogHeader</td>
                <td className="py-2 text-muted-foreground">Header section</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">DialogTitle</td>
                <td className="py-2 text-muted-foreground">Dialog title</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">DialogDescription</td>
                <td className="py-2 text-muted-foreground">Description text</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">DialogFooter</td>
                <td className="py-2 text-muted-foreground">Footer for actions</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
